import * as z from 'zod'

export const workflowInputSchema = z.object({
  /** The userId the job is running for. */
  userId: z.string(),
  /** Present and non-empty when the job exported one space rather than the account (spec §4) */
  rootEntityId: z.string().describe('The subtree this export was rooted at').optional(),
})
export type WorkflowInput = z.infer<typeof workflowInputSchema>

export const workflowOutputSchema = workflowInputSchema.extend({
  name: z.string(),
  status: z.enum(['ABORTED', 'FAILED', 'RUNNING', 'SUCCEEDED', 'TIMED_OUT', 'PENDING_REDRIVE']),
  startDate: z.iso.datetime(),
  stopDate: z.iso.datetime(),
  /** Extend this */
  input: workflowInputSchema.loose(),
  output: z.unknown(),
})
export type WorkflowOutput = z.infer<typeof workflowOutputSchema>
